// extracted by css-extract-rspack-plugin
export default {"popover-wrapper":"E9EzjW","popoverWrapper":"E9EzjW","popover-wrapper-relaxed":"RNtOG5","popoverWrapperRelaxed":"RNtOG5","root":"atUXH4"};